<template>
  <div class="container">
    <MdHeaderBar
      v-if="!hideNavBar"
      :is-custom-back="true"
      @back="$store.commit('setUnregisteredSite', true); $router.back()"
      :hide_close="true"
      :hide_back="false"
      :title="{
        isSingle: true,
        primary: isReadOnly ? $t('register.view_unregistered_site') : $t('register.modify_unregistered_site')
      }" />
    <div class="container scroll-body" :style="{paddingTop : hideNavBar ? '10px' : ''}">
      <md-form-group
        :required="true"
        :enable_multi_select="false"
        :label="$t('register.site_name')">
        <div slot="checkbox_right" style="display: flex; flex: 1; justify-content: flex-end">
          <img class="emphasize_dot" src="../../../../../src/assets/image/ic_dot_red.png">
          <span class="ml-2 caption_red_desc">{{$t('site_detail.require_field_desc')}}</span>
        </div>
        <b-form-input class="input_wrapper input"
                      :disabled="isReadOnly"
                      v-model="info.name" @change="$refs.inputAddress.focus()"
                      :placeholder="$t('more.site_name_placeholder')" ref="siteName" />
      </md-form-group>
      <md-form-group
        :required="true"
        :enable_multi_select="false"
        :label="$t('register.address')" >
        <div class="align-horizontal mb-2">
          <div class="left_wrapper" :style="{width: isReadOnly ? '100%' : ''}">
            <b-form-input
              ref="inputAddress"
              v-model="info.address1"
              @change="$refs.inputAddressDetail.focus()"
              class="input_wrapper input"
              :class="{'mr-1' : !isReadOnly}"
              disabled
              :placeholder="$t('more.search_address')"/>
          </div>
          <b-button v-if="!isReadOnly" class="func_btn btn_text btn_right" variant="primary" @click="showAddressPopup=true">
            {{$t('more.address_search')}}
          </b-button>
        </div>
        <b-form-input
          v-model="info.address2"
          :disabled="isReadOnly"
          ref="inputAddressDetail"
          @change="$refs.inputContactName.focus()"
          class="input_wrapper input"
          :placeholder="$t('more.detail_address_placeholder')" />
      </md-form-group>
      <md-form-group
        :required="true"
        :enable_multi_select="false"
        :label="$t('community.phone')">
        <div class="align-vertical">
          <div v-for="(contact, idx) in info.contact_list"
               class="align-horizontal mb-2">
            <div class="left_wrapper" :style="{width: isReadOnly ? '100%' : ''}">
              <b-form-input
                :disabled="isReadOnly"
                v-model="contact.name"
                placeholder="홍길동"
                class="input_wrapper input input_wrapper_lg mr-1" />
              <b-form-input
                v-model="contact.phone"
                :formatter="formatPhoneNumber"
                placeholder="010-0000-0000"
                class="input_wrapper input"
                :disabled="isReadOnly"
                :class="{'mr-1' : !isReadOnly}"
                style="text-align: center"
              />
            </div>
            <b-button v-if="!isReadOnly" class="delete_btn" variant="white" @click="onDelContact(idx)">
              <b-img style="width: 1rem; height: 1rem" :src="require('../../../../assets/image/ic_close3@2x.png')" />
            </b-button>
          </div>
          <div class="align-horizontal" v-if="info.contact_list.length < 5 && !isReadOnly">
            <div class="left_wrapper">
              <b-form-input
                v-model="contact_name"
                ref="inputContactName"
                @change="$refs.inputContactPhone.focus()"
                placeholder="홍길동"
                class="input_wrapper input mr-1 input_wrapper_lg" />
              <b-form-input
                ref="inputContactPhone"
                v-model="contact_phone"
                :formatter="formatPhoneNumber"
                placeholder="010-0000-0000"
                class="input_wrapper input mr-1"
                style="text-align: center"
              />
            </div>
            <b-button v-if="info.contact_list.length < 5" class="func_btn btn btn_text" variant="primary" @click="onAddContact">
              {{$t('admin_member.add')}}
            </b-button>
          </div>
        </div>
      </md-form-group>
      <md-form-group
        :label="$t('site_detail.site_type')"
        :enable_multi_select="true">
        <b-button
          variant="white"
          class="toggle_btn toggle_btn_text"
          v-for="(label, idx) in $t('maemul_type')" :key="idx"
          :pressed="getMultipleState(idx, 'maemul_type')"
          @click="() => {
            if (!isReadOnly) {
              onMultiSelect(idx, 'maemul_type')
            }
          }">{{label}}</b-button>
      </md-form-group>
      <md-form-group
        :label="$t('map.trans_type')"
        :enable_multi_select="true">
        <b-button
          variant="white"
          class="toggle_btn toggle_btn_text"
          v-for="(v,k,i) in $c.TRANS_TYPE" v-if="v!=''" :key="k"
          :pressed="getMultipleState(i - 1, 'trans_type')"
          @click="() => {
            if (!isReadOnly) {
              onMultiSelect(i - 1, 'trans_type');
            }
          }">{{k}}</b-button>
      </md-form-group>
      <md-form-group
        :label="$t('map.room_nums')"
        :enable_multi_select="true">
        <div class="align-horizontal">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            v-for="(val, idx) in $c.ROOM_NUM_SELECT.filter((it, _idx) => {return _idx > 0})" :key="idx"
            :pressed="self.info.room_num.split(',').includes(idx+'')"
            @click="() => {
                onMultiSelect('' + idx, 'room_num');
              }">{{val}}</b-button>
          <MFSelect
            class="btn toggle_btn toggle_btn_text ml-2"
            :class="{'active' : self.info.room_more > 4}"
            style="width: fit-content"
            :vmodel="self.info.room_more == '' ? $t('common.select') : self.info.room_more"
            :drop="true"
            @change="(value) => {
              self.info.room_more = value == $t('common.select') ? '' : value
              if(self.info.room_more == '')
                self.info.room_num = self.info.room_num.split(',').filter((it) => {return Number(it) < 5}).join(',')
              else
                self.info.room_num = self.info.room_num.split(',').filter((it) => {return Number(it) < 5}).join(',') + ',' + self.info.room_more;
            }"
            :options="more_room_num_list"
          />
          <!-- <b-form-select class="toggle_btn toggle_btn_text ml-2"
                         :class="{'active' : self.info.room_more > 4}"
                         style="width: fit-content"
                         v-model="self.info.room_more"
                         @change="($event) => {
                           if(self.info.room_more == '')
                             self.info.room_num = self.info.room_num.split(',').filter((it) => {return Number(it) < 5}).join(',')
                           else
                             self.info.room_num = self.info.room_num.split(',').filter((it) => {return Number(it) < 5}).join(',') + ',' + self.info.room_more;
                           }">
            <option v-for="(val, idx) in more_room_num_list" :key="`room_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
          </b-form-select> -->
        </div>
      </md-form-group>
      <md-form-group
        :label="$t('map.toilet_nums')"
        :enable_multi_select="true">
        <div class="align-horizontal">
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            v-for="(val, idx) in Object.keys($c.MF_TOILET)" :key="idx"
            :pressed="self.info.toilet_num.split(',').includes($c.MF_TOILET[val])"
            @click="() => {onMultiSelect(idx+1, 'toilet_num')}">{{val}}</b-button>
          <MFSelect
            class="btn toggle_btn toggle_btn_text ml-2"
            :class="{'active' : self.info.toilet_more > 3}"
            style="width: fit-content"
            :vmodel="self.info.toilet_more == '' ? $t('common.select') : self.info.toilet_more"
            :drop="true"
            @change="(value) => {
              self.info.toilet_more = value == $t('common.select') ? '' : value
              if(self.info.toilet_more == '')
                self.info.toilet_num = self.info.toilet_num.split(',').filter((it) => {return Number(it) < 4}).join(',')
              else
                self.info.toilet_num = self.info.toilet_num.split(',').filter((it) => {return Number(it) < 4}).join(',') + ',' + self.info.toilet_more;
            }"
            :options="more_toilet_num_list"
          />
          <!-- <b-form-select class="toggle_btn toggle_btn_text ml-2"
                         :class="{'active' : self.info.toilet_more > 3}"
                         style="width: fit-content"
                         v-model="self.info.toilet_more"
                         @change="($event) => {
                           if(self.info.toilet_more == '')
                             self.info.toilet_num = self.info.toilet_num.split(',').filter((it) => {return Number(it) < 4}).join(',')
                           else
                             self.info.toilet_num = self.info.toilet_num.split(',').filter((it) => {return Number(it) < 4}).join(',') + ',' + self.info.toilet_more;
                         }">
            <option v-for="(val, idx) in more_toilet_num_list" :key="`toilet_more_${idx}`" :value="idx > 0 ? val : ''">{{val}}</option>
          </b-form-select> -->
        </div>
      </md-form-group>
      <md-form-group :label="$t('interest.open_date')">
        <div class="align-horizontal">
          <MFSelect
            class="input_wrapper input input_wrapper_sm"
            :vmodel="info.open_date_y"
            :drop="true"
            @change="(value) => {
              info.open_date_y = value;
              info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)
            }"
            :options="year_list"
            :disabled="isReadOnly"
          />
          <!-- <b-form-select class="input_wrapper input input_wrapper_sm"
                         :disabled="isReadOnly"
                         v-model="info.open_date_y"
                         @change="($event) => {info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)}"
                         :options="year_list" /> -->
          <span class="input_caption mr-2 ml-2">년</span>
          <MFSelect
            class="input_wrapper input input_wrapper_sm"
            :vmodel="info.open_date_m"
            :drop="true"
            @change="(value) => {
              info.open_date_m = value;
              info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)
            }"
            :options="month_list"
            :disabled="isReadOnly"
          />
          <!-- <b-form-select class="input_wrapper input input_wrapper_sm"
                         :disabled="isReadOnly"
                         v-model="info.open_date_m"
                         @change="($event) => {info.open_date = info.open_date_y + '-' +  u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)}"
                         :options="month_list" /> -->
          <span class="input_caption mr-2 ml-2">월</span>
          <MFSelect
            class="input_wrapper input input_wrapper_sm"
            :vmodel="info.open_date_d"
            :drop="true"
            @change="(value) => {
              info.open_date_d = value;
              info.open_date = info.open_date_y + '-' + u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)
            }"
            :options="day_list"
            :disabled="isReadOnly"
          />
          <!-- <b-form-select class="input_wrapper input input_wrapper_sm"
                         :disabled="isReadOnly"
                         v-model="info.open_date_d"
                         @change="($event) => {info.open_date = info.open_date_y + '-' +  u.pad(info.open_date_m, 2) + '-' + u.pad(info.open_date_d, 2)}"
                         :options="day_list"/> -->
          <span class="input_caption mr-2 ml-2">일</span>
        </div>
      </md-form-group>
      <div class="align-vertical md_form_group_unit">
        <div class="align-horizontal" style="justify-content: space-between; align-items: baseline">
          <md-form-group :label="$t('register.inlay_reg')" />
          <div v-if="!isReadOnly">
            <b-form-file multiple v-model="inlay_image" class="" accept="image/*" ref="inlayImageBrowser" style="display: none" @input="uploadImage(inlay_image, 'I')"></b-form-file>
            <b-button class="remove_img_btn btn_text btn_right mr-1" variant="secondary" @click="onRemoveImage">
              {{$t('common.delete')}}
            </b-button>
            <b-button class="attach_btn btn_text btn_right" variant="primary" @click="$refs.inlayImageBrowser.$el.querySelector('input[type=file]').click()">
              {{$t('common.attach')}}
            </b-button>
          </div>
        </div>
        <div class="align-vertical" v-show="info.inlay_image_url_list.length > 0" style="position: relative; margin-top: 10px;">
          <b-carousel
            ref="i_carousel"
            :interval="0"
            v-model="activeInlayIndex"
            controls
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333; z-index: 0"
          >
            <b-carousel-slide
              v-for="img in info.inlay_image_url_list"
              :img-src="img"
            >
              <template slot="img">
                <b-img
                  width="1024"
                  height="480"
                  style="width: 100%"
                  @click="onGallery('I')"
                  :src="img"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
          <carousel-indicator :length="info.inlay_image_url_list.length" :active="activeInlayIndex"/>
        </div>
      </div>
      <md-form-group :label="$t('site_report.want_say_manager2')">
        <b-form-textarea
          :placeholder="$t('site_report.want_say_manager_placeholder')"
          :rows="isReadOnly ? Math.max(5, info.memo.split('\n').length + 1 ) : 5"
          :disabled="isReadOnly"
          ref="inputContent"
          v-model="info.memo"
          style="padding: 5px 10px"
          class="input"></b-form-textarea>
      </md-form-group>
      <div class="align-horizontal">
        <b-button v-if="!isReadOnly" class="temporary_btn reg_btn_text no_border_radius" style="flex: 1" variant="primary"
                  @click="onSave">
          {{hideNavBar ? $t('site_report.report_btn') : $t('common.modify1')}}
        </b-button>
      </div>
    </div>
    <AddressSearchPopup
      :visible.sync="showAddressPopup"
      @onConfirm="(address, detailAddress) => {
        info.address1 = address;
        info.address2 = detailAddress;
        info.latitude = this.myinfo.tmpLatitude;
        info.longitude = this.myinfo.tmpLongitude;
      }"
    />
    <Gallery
      :visible.sync="galleryPopupShow"
      :src="which == 'I' ? info.inlay_image_url_list : info.image_urls_list"
      :current="which == 'I' ? activeInlayIndex : activeIndex"
    />
  </div>
</template>

<script>
import MdHeaderBar from "../../../controls/MdHeaderBar";
import MdFormGroup from "../../../controls/MdFormGroup";
import MFSelect from "../../../controls/mf/MFSelect";
import MdSingleCheckBox from "../../../controls/mf/MdSingleCheckBox";
import moment from "moment";
import CarouselIndicator from "../../../controls/CarouselIndicator";
import Utils from "../../../../config/utils"
import AddressSearchPopup from "../../../controls/popup/AddressSearchPopup";
import Gallery from "../../../controls/Gallery";
export default {
  name: "UnregisteredSite",
  components: {AddressSearchPopup, CarouselIndicator, MdSingleCheckBox, MdFormGroup, MdHeaderBar, Gallery, MFSelect},
  props: {
    hideNavBar: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    let oldInfo = null;
    let contactList = [];
    if (this.$route.params.common != null) {
      oldInfo = this.$route.params.common;
    }
    if (this.$route.params.contact_list != null) {
      contactList = this.$route.params.contact_list;
      contactList = contactList.map(item => {
        return {
          name: item.f_name,
          phone: item.f_phone
        };
      });
    }
    let ho_list = null;
    if (this.$route.params.ho_list != null) {
      ho_list = this.$route.params.ho_list;
    }

    let dong_list = [];
    if (this.$route.params.dong_list != null) {
      dong_list = this.$route.params.dong_list;
    }

    let roomList = [];
    if (this.$route.params.room_list != null) {
      roomList = this.$route.params.room_list;
      roomList = roomList.map(item => {
        return {
          area: item.f_area,
          room: parseInt(item.f_room),
          pyong: item.f_area == 'E' ? item.f_exclusive_pyong : item.f_real_pyong,
          square: item.f_area == 'E' ? item.f_exclusive_square : item.f_real_square,
          duplex: item.f_duplex
        };
      });
    }

    return {
      u: Utils,
      self: this,
      dropdownList:[],
      activeIndex: 0,
      activeInlayIndex: 0,
      which: 'I', // I, P,
      isReadOnly: Utils.isEmpty(this.$route.params) ? false : this.$route.params.isReadOnly,
      inlay_image: null,
      image: null,
      galleryPopupShow: false,
      info: {
        site_idx: oldInfo ? oldInfo.f_idx : -1,
        site_type: oldInfo ? oldInfo.f_site_type : 'U',
        name: oldInfo ? oldInfo.f_name : '',
        address1: oldInfo ? oldInfo.f_address1 : '',
        address2: oldInfo ? oldInfo.f_address2 : '',
        latitude: oldInfo ? oldInfo.f_latitude : 0,
        longitude: oldInfo ? oldInfo.f_longitude : 0,
        contact_list: contactList,
        maemul_type: oldInfo ? oldInfo.f_maemul_type : '',
        dong_count: oldInfo && oldInfo.f_dong_count != '0' ? oldInfo.f_dong_count : '',
        house_count: oldInfo && oldInfo.f_house_count != '0' ? oldInfo.f_house_count : '',
        parking_type: oldInfo ? oldInfo.f_parking_type : '',
        trans_type: oldInfo ? oldInfo.f_transaction_type : '',
        room_num: oldInfo && oldInfo.f_room_num? oldInfo.f_room_num : '',
        room_more: (oldInfo == null || oldInfo && oldInfo.f_room_num.split(',').filter((it) => {return Number(it) > 4}).length < 1) ? '' : oldInfo.f_room_num.split(',').filter((it) => {return Number(it) > 4})[0],
        // toilet: this._hoInfo != null ? this._hoInfo.toilet : this.toiletNum[0],
        toilet_num: oldInfo && oldInfo.f_toilet_num ? oldInfo.f_toilet_num : '',
        toilet_more: (oldInfo == null || oldInfo && oldInfo.f_toilet_num.split(',').filter((it) => {return Number(it) > 3}).length < 1) ? '' : oldInfo.f_toilet_num.split(',').filter((it) => {return Number(it) > 3})[0],
        duplex: oldInfo ? oldInfo.f_duplex : 'N',
        site_inquire_price: oldInfo ? oldInfo.f_site_inquire_price : 'N',
        site_inquire_charter: oldInfo ? oldInfo.f_site_inquire_charter : 'N',
        site_inquire_investment: oldInfo ? oldInfo.f_site_inquire_investment : 'N',
        site_inquire_month: oldInfo ? oldInfo.f_site_inquire_month : 'N',
        inlay_private: oldInfo ? oldInfo.f_inlay_private : 'N',
        elevator: oldInfo ? oldInfo.f_elevator : 'N',
        area_type: oldInfo ? oldInfo.f_area_type : 'E',
        room_list: roomList,
        fee_type: oldInfo ? oldInfo.f_fee_type : 'T',
        open_date: oldInfo ? oldInfo.f_open_date : moment().year() + "-01-01",
        open_date_y: oldInfo ? moment(oldInfo.f_open_date).year() : moment().year(),
        open_date_m: parseInt(oldInfo ? moment(oldInfo.f_open_date).month() : 0) + 1,
        open_date_d: parseInt(oldInfo ? moment(oldInfo.f_open_date).date() : 1),
        temporary_save: 'N',
        drop_off: 'Y',
        house_info: [],
        sale_price_min: oldInfo && oldInfo.f_sale_price_min != '0' ? oldInfo.f_sale_price_min : '',
        sale_price_max: oldInfo && oldInfo.f_sale_price_max != '0' ? oldInfo.f_sale_price_max : '',
        charter_price_min: oldInfo && oldInfo.f_charter_price_min != '0' ? oldInfo.f_charter_price_min : '',
        charter_price_max: oldInfo && oldInfo.f_charter_price_max != '0' ? oldInfo.f_charter_price_max : '',
        safe_charter: oldInfo ? oldInfo.f_safe_charter : 'N',
        smb: oldInfo ? oldInfo.f_smb : 'N',
        invest_price_min: oldInfo && oldInfo.f_invest_price_min != '0' ? oldInfo.f_invest_price_min : '',
        invest_price_max: oldInfo && oldInfo.f_invest_price_max != '0' ? oldInfo.f_invest_price_max : '',
        monthly_rent_deposit: oldInfo && oldInfo.f_monthly_rent_deposit != '0' ? oldInfo.f_monthly_rent_deposit : '',
        monthly_rent_min: oldInfo && oldInfo.f_monthly_rent_min != '0' ? oldInfo.f_monthly_rent_min : '',
        monthly_rent_max: oldInfo && oldInfo.f_monthly_rent_max != '0' ? oldInfo.f_monthly_rent_max : '',
        fee_trading: oldInfo && oldInfo.f_fee_trading != '0' ? oldInfo.f_fee_trading : '1',
        fee_charter_type: oldInfo ? oldInfo.f_fee_charter_type : 0,
        fee_charter: oldInfo && oldInfo.f_fee_charter != '0' ? oldInfo.f_fee_charter : '',
        fee_invest: oldInfo && oldInfo.f_fee_invest != '0' ? oldInfo.f_fee_invest : '',
        inlay_image_url_list: (oldInfo == null || oldInfo.f_inlay_image_url == null) ? [] : oldInfo.f_inlay_image_url.split(',').filter(it => {
          return !Utils.isEmptyOrNull(it)
        }),
        image_urls_list: (oldInfo == null || oldInfo.f_image_urls == null) ? [] : oldInfo.f_image_urls.split(',').filter(it => {
          return !Utils.isEmptyOrNull(it)
        }),
        memo: oldInfo ? oldInfo.f_memo : '',
        status: oldInfo ? oldInfo.f_status : 'N',
      },
      dong_list: dong_list,
      ho_list: ho_list,
      contact_name: '',
      contact_phone: '',
      showAddressPopup: false,
      exclusive_area_room: -1,
      exclusive_area_room_duplex: 'N',
      exclusive_area_room_m2: '',
      exclusive_area_room_pyong: '',
      real_area_room: -1,
      real_area_room_duplex: 'N',
      real_area_room_m2: '',
      real_area_room_pyong: ''
    };
  },
  computed: {
    year_list() {
      let list = [];
      for(let year = parseInt(this.info.open_date_y) - 5; year < parseInt(this.info.open_date_y) + 5; year ++)
        list.push(year);
      return list;
    },
    month_list() {
      let list = [];
      for(let month = 1; month <=12; month ++)
        list.push(month);
      return list;
    },
    day_list() {
      let list = [];
      for(let day = 1; day <=12; day ++)
        list.push(day);
      return list;
    },
    room_dropdown_list() {
      let room_num_list = this.$c.ROOM_NUM_SELECT.filter((it, idx) => {
        return idx > 0
      });
      let room_dropdown_list = [];
      room_num_list.filter((it, idx) => {
        return this.info.room_num.includes(`${idx}`)
      }).forEach(it => {
        room_dropdown_list.push({
          name: it,
          index: room_num_list.indexOf(it),
          duplex: 'N'
        });
        if (this.info.duplex == 'Y') {
          room_dropdown_list.push({
            name: it + '(' +this.$t('room_info_popup.duplex') + ')',
            index: room_num_list.indexOf(it),
            duplex: 'Y'
          });
        }
      });
      return room_dropdown_list;
    },
    more_room_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_ROOM_CNT, 5))
    },
    more_toilet_num_list () {
      return [this.$t('common.select')].concat(Utils.getNumList(this.$c.MAX_TOILET_CNT, 4))
    },
  },
  async mounted() {
    let tempStep = await this.$perf.getInt(this.$c.PREF_PARAMS.TEMP_STEP);
    if (tempStep > 1 && this.state.info.site_idx > 0) {
      this.onNextStep();
    }
  },
  inject: ["eventBus"],
  methods: {
    formatPhoneNumber(value) {
      return Utils.formatPhoneNumber(value)
    },
    getMultipleState(item, which)
    {
      return this.info[which].includes(item);
    },
    onAddContact() {
      let { info, contact_name, contact_phone } = this;

      if (info.contact_list.length >= 5) {
        return;
      }

      if (contact_name == '' || contact_phone == '') {
        return;
      }
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          contact_list: this.info.contact_list.concat([
            { name: contact_name, phone: contact_phone },
          ]),
        }),
        contact_name: '',
        contact_phone: '',
      });
    },
    onDelContact(idx) {
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          contact_list: this.info.contact_list.filter((it, index) => {
            return idx != index;
          }),
        }),
      });
    },
    onDelAreaInfo(idx) {
      Utils.setState(this, {
        info: Object.assign({}, this.info, {
          room_list: this.info.room_list.filter((it, index) => {
            return idx != index;
          }),
        }),
      }, () => {
        this.info.room_list.forEach((it, index) => {
          if (this.dropdownList[index]) {
            this.dropdownList[index].choose(this.room_dropdown_list.findIndex(drop => {
              return drop.duplex == it.duplex && Number(drop.index) == Number(it.room)
            }));
          }
        })
      });
    },
    onSingleSelect(item, which){
      this.info[which]= item + '';
    },
    onMultiSelect (item, which) {
      item = item + "";
      let oldValue = this.info[which];
      oldValue = oldValue.split(',');
      if (oldValue.indexOf(item + '') > -1) {
        oldValue.splice(oldValue.indexOf(item), 1);
      } else {
        oldValue.push(item);
      }

      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          [which]: oldValue.join(','),
        }),
      });
    },

    onGallery(which) {
      this.galleryPopupShow=true;
      this.which=which;
    },
    onRemoveImage() {
      let { info, activeInlayIndex } = this;
      let image_url_list = info.inlay_image_url_list;

      if (image_url_list.length <= 0) {
        return;
      }
      if (image_url_list.length - 1 < activeInlayIndex) {
        return;
      }
      image_url_list.splice(activeInlayIndex, 1);
      if (image_url_list.length == 0) {
        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            inlay_image_url_list: []
          }),
          activeInlayIndex: 0
        });
        return;
      }
      if (activeInlayIndex > image_url_list.length - 1) {
        activeInlayIndex = image_url_list.length - 1
      }
      Utils.setState(this,{
        info: Object.assign({}, this.info, {
          inlay_image_url_list: image_url_list
        }),
        activeInlayIndex: activeInlayIndex
      });
    },

    uploadImage(file, which) {
      this.which = which;
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '1'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          if (this.which == 'I'){
            Utils.setState(this,{
              info: Object.assign({}, this.info, {
                inlay_image_url_list: this.info.inlay_image_url_list.concat(result.data.url)
              }),
            }, () => {
              this.activeInlayIndex = this.info.inlay_image_url_list.length - 1;
            });
          }
          if (this.which == 'P') {
            Utils.setState(this,{
              info: Object.assign({}, this.info, {
                image_urls_list: this.info.image_urls_list.concat(result.data.url)
              }),
            }, () => {
              this.activeIndex = this.info.image_urls_list.length - 1;
            });
          }
        } else {
          Utils.toast(this, result.msg);
        }
      })
        .catch((error) => {
          Utils.toast(this, this.$t('common.upload_image_error'));
        });
    },

    onSave() {
      let regInfo = this.info;
      if (Utils.isEmptyOrNull(regInfo.name)) {
        Utils.toast(this, this.$t('more.site_name_placeholder'));
        this.$refs.siteName.focus();
        return;
      }
      if (Utils.isEmptyOrNull(regInfo.address1) && Utils.isEmptyOrNull(regInfo.address2)) {
        Utils.toast(this, this.$t('more.address_placeholder'));
        this.$refs.inputAddress.focus();
        return;
      }

      let { contact_name, contact_phone } = this;
      if (contact_name != '' && contact_phone != '' && regInfo.contact_list.length < 5) {
        regInfo.contact_list = regInfo.contact_list.concat([
          { name: contact_name, phone: contact_phone },
        ]);
        Utils.setState(this,{
          info: Object.assign({}, this.info, {
            contact_list: regInfo.contact_list,
          }),
          contact_name: '',
          contact_phone: '',
        });
      }

      if (regInfo.contact_list.length == 0) {
        Utils.toast(this, this.$t('register.contact_placeholder'));
        this.$refs.inputContactName.focus();
        return;
      }

      regInfo.sale_price_min = 0;
      regInfo.sale_price_max = 0;

      regInfo.charter_price_min = 0;
      regInfo.charter_price_max = 0;

      regInfo.invest_price_min = 0;
      regInfo.invest_price_max = 0;

      regInfo.monthly_rent_min = 0;
      regInfo.monthly_rent_max = 0;

      if (Utils.isEmptyOrNull(regInfo.fee_type)) {
        Utils.toast(this, this.$t('register.fee_type_placeholder'));
        return;
      }

      if (regInfo.fee_type.includes('C')) {
        if (Utils.isEmptyOrNull(regInfo.fee_charter)) {
          regInfo.fee_charter = '0';
          // Utils.toast(this, this.$t('register.fee_info_placeholder'));
          // return;
        }
      }
      if (regInfo.fee_type.includes('I')) {
        if (Utils.isEmptyOrNull(regInfo.fee_invest)) {
          Utils.toast(this, this.$t('register.fee_info_placeholder'));
          return;
        }
      }

      if (regInfo.image_urls_list.length > 0) {
        regInfo.image_urls = regInfo.image_urls_list.join(',');
      }
      if (regInfo.inlay_image_url_list.length > 0) {
        regInfo.inlay_image_url = regInfo.inlay_image_url_list.join(',');
      }
      if (regInfo.contact_list.length > 0) {
        regInfo.contacts = JSON.stringify(regInfo.contact_list);
      }

      if (regInfo.room_list.length > 0) {
        regInfo.rooms = JSON.stringify(regInfo.room_list);
      }

      regInfo.temporary_save = 'N';
      regInfo.drop_off = 'N';

      regInfo.site_type = 'U'

      Utils.requestPost(
        regInfo.site_idx > -1 ? this.$c.API.Site.updateSite : this.$c.API.Site.addSite,
        regInfo
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('common.save_success'));
          if(!this.hideNavBar)
            this.eventBus.$emit('sale_modify', regInfo.site_idx);
          this.onCancel()
        } else {
          Utils.toast(this, result.msg);
        }
      });

    },

    onCancel() {
      if (this.hideNavBar)
        this.$emit('cancel');
      else {
        this.$store.commit('setUnregisteredSite', true);
        this.$router.back();
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../assets/css/main/more/RegNewOpenSite1";

$btn_right_width: 80px;
$input_wrapper_sm_width: 100px;
$input_wrapper_lg_width: 300px;

.form-control:disabled {
  background-color: white;
}
.scroll-body {
  //overflow: auto;
  padding-top: $md_header_height;
}
.btn_right {
  width: $btn_right_width;
}
.left_wrapper {
  width: calc(100% - #{$btn_right_width});
  display: flex;
  flex-direction: row;
}
.input_wrapper_sm {
  width: $input_wrapper_sm_width;
  text-align: center;
}
.input_wrapper_lg {
  width: $input_wrapper_lg_width;
  text-align: center;
}
.input_disabled {
  background-color: #E1E1E1!important;
  color: #E1E1E1!important;
}
.emphasize_dot {
  position: relative;
  top: 1px;
  left: 1px;
  z-index: -9999;
  width: 5px;
  height: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/main/more/UnregisteredSite.vue